module.exports = __webpack_public_path__ + "static/images/left-arrow-square.79947f404c34a7a977331fb09dc40e3d.svg";